// import React, { useState } from "react";

// const subadmins = [
//   {
//     subadminId: "SUB001",
//     subadminName: "Kochi Subadmin",
//     sellersManaged: 12,
//     totalCommission: "₹32,000",
//     payableAmount: "₹18,000",
//   },
//   {
//     subadminId: "SUB002",
//     subadminName: "Thrissur Subadmin",
//     sellersManaged: 8,
//     totalCommission: "₹21,500",
//     payableAmount: "₹0",
//   },
//   {
//     subadminId: "SUB003",
//     subadminName: "Calicut Subadmin",
//     sellersManaged: 15,
//     totalCommission: "₹40,000",
//     payableAmount: "₹22,000",
//   },
// ];

// const SubadminPayouts = () => {
//   const [modal, setModal] = useState(null);

//   return (
//     <div className="p-6 space-y-6">
//       {/* Summary (Dummy) */}
//       <div className="grid grid-cols-3 gap-4">
//         <SummaryCard title="Total Subadmins" value="3" />
//         <SummaryCard title="Total Commission Payable" value="₹40,000" />
//         <SummaryCard title="Total Sellers Managed" value="35" />
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-lg shadow overflow-x-auto">
//         <table className="w-full text-sm">
//           <thead className="bg-blue-50 text-left">
//             <tr>
//               <th className="p-3">Subadmin</th>
//               <th className="p-3">Sellers Managed</th>
//               <th className="p-3">Total Commission</th>
//               <th className="p-3">Payable Amount</th>
//               <th className="p-3">Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {subadmins.map((s) => (
//               <tr key={s.subadminId} className="border-t">
//                 <td className="p-3">
//                   <p className="font-medium">{s.subadminName}</p>
//                   <p className="text-xs text-gray-500">{s.subadminId}</p>
//                 </td>

//                 <td className="p-3">{s.sellersManaged}</td>

//                 <td className="p-3 font-semibold">
//                   {s.totalCommission}
//                 </td>

//                 <td className="p-3 text-green-700 font-semibold">
//                   {s.payableAmount}
//                 </td>

//                 <td className="p-3">
//                   <button
//                     onClick={() =>
//                       setModal({
//                         subadminId: s.subadminId,
//                         amount: s.payableAmount,
//                       })
//                     }
//                     className="px-3 py-1 bg-blue-600 text-white rounded text-xs"
//                   >
//                     Pay Subadmin
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {modal && (
//         <PayoutModal
//           {...modal}
//           onClose={() => setModal(null)}
//         />
//       )}
//     </div>
//   );
// };

// const SummaryCard = ({ title, value }) => (
//   <div className="bg-white rounded-lg shadow p-4">
//     <p className="text-sm text-gray-500">{title}</p>
//     <p className="text-xl font-bold text-blue-700">
//       {value}
//     </p>
//   </div>
// );

// const PayoutModal = ({ subadminId, amount, onClose }) => {
//   const handleSubmit = () => {
//     console.log("DUMMY SUBADMIN PAYOUT →", {
//       subadminId,
//       amount,
//     });
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg w-full max-w-sm p-6 space-y-4">
//         <h2 className="text-lg font-bold">Pay Subadmin</h2>

//         <div className="text-sm text-gray-700 space-y-1">
//           <p>Subadmin ID: <b>{subadminId}</b></p>
//           <p>Amount: <b>{amount}</b></p>
//         </div>

//         <div className="flex justify-end gap-2">
//           <button
//             onClick={onClose}
//             className="px-3 py-1 border rounded text-sm"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="px-4 py-1 bg-blue-600 text-white rounded text-sm"
//           >
//             Confirm Payment
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SubadminPayouts;







import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getSubadminPayouts,
  paySubadminCommission,
} from "../../ApiCalls/Revenue";

/* ================================
   SUBADMIN PAYOUT LIST PAGE
================================ */

const SubadminPayouts = () => {
  const navigate = useNavigate();

  const [summary, setSummary] = useState(null);
  const [subadmins, setSubadmins] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubadminPayouts();
  }, []);

  const fetchSubadminPayouts = async () => {
    try {
      const res = await getSubadminPayouts();
      setSummary(res.data.summary);
      setSubadmins(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch subadmin payouts", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6 text-sm text-gray-500">
        Loading subadmin payouts...
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-xl font-bold text-green-700">
        Subadmin Payouts
      </h1>

      {/* SUMMARY */}
      {summary && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <SummaryCard
            title="Total Subadmins"
            value={summary.total_subadmins}
          />
          <SummaryCard
            title="Subadmin Commission Payable"
            value={`₹${summary.total_subadmin_commission_payable}`}
          />
          <SummaryCard
            title="Total Sellers Managed"
            value={summary.total_sellers_managed}
          />
        </div>
      )}

      {/* TABLE */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-green-50 text-left">
            <tr>
              <th className="p-3">Subadmin</th>
              <th className="p-3">Commission %</th>
              <th className="p-3">Sellers Managed</th>
              <th className="p-3">Lifetime Paid</th>
              <th className="p-3">Pending Commission</th>
              <th className="p-3">Admin Share</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {subadmins.map((s) => (
              <tr key={s.subadmin_id} className="border-t">
                <td className="p-3">
                  <p className="font-medium">{s.name}</p>
                  <p className="text-xs text-gray-500">{s.email}</p>
                </td>

                <td className="p-3">
                  {s.commission_percentage}%
                </td>

                <td className="p-3">
                  {s.sellers_managed_count}
                </td>

                <td className="p-3 text-blue-700 font-medium">
                  ₹{s.lifetime_paid_commission}
                </td>

                <td className="p-3 font-semibold text-green-700">
                  ₹{s.pending_subadmin_commission}
                </td>

                <td className="p-3 text-red-600 font-medium">
                  ₹{s.pending_admin_share}
                </td>

                <td className="p-3 flex gap-2">
                  <button
                    onClick={() =>
                      navigate(
                        `/admin/subadminpayout/${s.subadmin_id}`
                      )
                    }
                    className="px-3 py-1 text-xs rounded border border-green-600 text-green-700"
                  >
                    View
                  </button>

                  <button
                    disabled={s.pending_subadmin_commission <= 0}
                    onClick={() =>
                      setModal({
                        subadminId: s.subadmin_id,
                        amount: s.pending_subadmin_commission,
                      })
                    }
                    className={`px-3 py-1 text-xs rounded text-white ${
                      s.pending_subadmin_commission > 0
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Pay
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PAY MODAL */}
      {modal && (
        <PayoutModal
          subadminId={modal.subadminId}
          amount={modal.amount}
          onClose={() => setModal(null)}
          onSuccess={fetchSubadminPayouts}
        />
      )}
    </div>
  );
};

export default SubadminPayouts;

/* ================================
   COMPONENTS
================================ */

const SummaryCard = ({ title, value }) => (
  <div className="bg-white rounded-lg shadow p-4">
    <p className="text-sm text-gray-500">{title}</p>
    <p className="text-xl font-bold text-green-700">
      {value}
    </p>
  </div>
);

/* ================================
   PAYOUT MODAL (POST INTEGRATED)
================================ */

const PayoutModal = ({
  subadminId,
  amount,
  onClose,
  onSuccess,
}) => {
  const [payAmount, setPayAmount] = useState(amount);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleConfirm = async () => {
    setSubmitting(true);
    setErrorMsg("");

    try {
      const res = await paySubadminCommission({
        subadmin_id: subadminId,
        amount: Number(payAmount),
      });

      if (res.data.status === 1) {
        alert(res.data.message || "Payment successful");
        onClose();
        onSuccess();
      } else {
        setErrorMsg(res.data.message);
      }
    } catch (error) {
      setErrorMsg("Payment failed. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-sm p-6 space-y-4">
        <h2 className="text-lg font-bold text-green-700">
          Pay Subadmin
        </h2>

        <div className="space-y-3 text-sm">
          <input
            value={subadminId}
            disabled
            className="w-full border rounded px-3 py-2 bg-gray-100"
          />

          <input
            type="number"
            min="0"
            value={payAmount}
            onChange={(e) =>
              setPayAmount(e.target.value)
            }
            className="w-full border rounded px-3 py-2"
          />

          {errorMsg && (
            <p className="text-xs text-red-600">
              {errorMsg}
            </p>
          )}
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>
          <button
            disabled={submitting}
            onClick={handleConfirm}
            className="px-4 py-1 bg-green-600 text-white rounded disabled:opacity-50"
          >
            {submitting ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};
